import "../../../../../node_modules/classnames/index.js";
import "../../../../utils/DomHandler.js";
import e from "../../../../utils/EventBus.js";
import "react";
var r = e();
export { r as OverlayService };